<form (ngSubmit)="onSubmit()" [formGroup]="form" class="vertical-form">


  <div fxLayout="column" class="mat-typography">
    <!-- ConsumerReferral Campaigns as Tabs -->
    <div fxLayout="row" style="margin-bottom: 10px;">
      <div fxLayout="row" fxLayoutAlign="start center" class="section-title" fxLayoutGap="10px">

        <!-- TabItem -->
        @for (grp of form.controls.consumerReferralCampaigns['controls']; track grp; let i = $index) {
        <div class="tab-item" [class.active]="selectedChannelIndex === i" (click)="selectedChannelIndex = i"
          [class.invalid]="dataValidations[i]?.invalid">
          {{ grp.value['channel'] || ('Channel ' + (i + 1)) }} @if (grp.value['isDefaultChannel']) {
          <span matTooltil="Default app channel">*</span>
          }
        </div>
        }


        @if (form.controls.consumerReferralCampaigns['controls'].length === 0) {
        <div>
          No Consumer Referral links
        </div>
        }

      </div>
      <div fxFlex></div>
      <lib-button icon="add" (buttonClick)="addConsumerReferral()">Add invite channel</lib-button>
    </div>

    <!-- Current ConsumerReferralCampaign (active tab) -->
    @for (grp of form.controls.consumerReferralCampaigns['controls']; track grp; let i = $index) {
    <div fxLayout="column" fxLayoutAlign="space-between" fxLayoutGap="5px">
      <div [fxShow]="selectedChannelIndex === i" class="box space-bottom" fxLayout="column" fxLayoutGap="5px">
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
          <mat-form-field fxFlex>
            <mat-label>Channel name</mat-label>
            <input type="text" matInput placeholder="" [formControl]="grp['controls'].channel" autocomplete="off">
            @if (grp.get('channel').touched && !grp.get('channel').valid) {
            <mat-error>Please enter channel
              name</mat-error>
            }
          </mat-form-field>
          <div>
            <mat-slide-toggle [formControl]="grp['controls'].isDefaultChannel" color="primary"
              (change)="onDefaultChannelChanged(i, $event)">
              <label class="form-label">Consumer to consumer</label>
            </mat-slide-toggle>
          </div>
          <div>
            <lib-button icon="delete" (buttonClick)="removeConsumerReferral(i)">Remove invite channel</lib-button>
          </div>
          <div>
            @if (!grp.value['isDefaultChannel'] && grp.value['inviteCode']) {
              <lib-button icon="share" (buttonClick)="getAdminInviteCode(i)">Share invite</lib-button>
            }
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
          <mat-form-field fxFlex>
            <mat-label>External onboarding url</mat-label>
            <input type="text" matInput placeholder="" [formControl]="grp['controls'].onboardingUrl" autocomplete="off">
            <!-- <mat-error *ngIf="grp.get('onboardingUrl').touched && !grp.get('onboardingUrl').valid">Please enter channel name</mat-error> -->
          </mat-form-field>
          <div>
            <!-- <mat-slide-toggle [formControl]="grp['controls'].isDefaultChannel" color="primary" (change)="onDefaultChannelChanged(i)">
                <label class="form-label">Default app channel</label>
              </mat-slide-toggle> -->
          </div>
          <div>
            <!-- <button (click)="removeConsumerReferral(i)"   mat-button color="primary" type="button" matTooltip="Remove link"><mat-icon>delete</mat-icon> Remove invite link</button> -->
          </div>
        </div>
        @if (grp.value['isDefaultChannel']) {
        <app-refferal-link-setting [data]="grp.value['referralLinkSettings']"></app-refferal-link-setting>
        <div style="height: 20px;">&nbsp;</div>
        @if (grp.value['isDefaultChannel']) {
        <div fxFlex class="section-title">
          <h2>Sender rewards</h2>
        </div>
        }
        @if (grp.value['isDefaultChannel']) {
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="16px">
          @if (isPunchCard || isConsumerInfo) {
          <app-reward-data-edit fxFlex [formControl]="grp['controls'].joinRewardSender" [advertiser]="advertiser"
            [rewardProductsOptions]="rewardProducts" [label]="'Join reward'" [allowCoins]="false"
            [allowStamps]="!isPoints" [allowPoints]="isPoints">
          </app-reward-data-edit>
          }
          @if (isPunchCard) {
          <app-reward-data-edit fxFlex [formControl]="grp['controls'].firstConsRewardSender" [advertiser]="advertiser"
            [rewardProductsOptions]="rewardProducts" [label]="'First consumption reward'" [allowCoins]="false"
            [allowStamps]="!isPoints" [allowPoints]="isPoints">
          </app-reward-data-edit>
          }
          @if (isPunchCard) {
          <app-reward-data-edit fxFlex [formControl]="grp['controls'].completeRewardSender" [advertiser]="advertiser"
            [rewardProductsOptions]="rewardProducts" [label]="'Complete reward'" [allowCoins]="false"
            [allowStamps]="!isPoints" [allowPoints]="isPoints">
          </app-reward-data-edit>
          }
        </div>
        }
        <div style="height: 20px;">&nbsp;</div>
        }
        <!-- SENDER (only PWA default channel has sender rewards) -->
        <!-- Receiver -->
        <div fxFlex class="section-title">
          <h2>Receiver rewards</h2>
        </div>
        <div fxLayout="column" fxLayoutAlign="space-between">
          @if (isPunchCard || isConsumerInfo) {
          <app-reward-data-edit fxFlex [hasToggle]="true" [formControl]="grp['controls'].joinRewardReceiver"
            [advertiser]="advertiser" [rewardProductsOptions]="rewardProducts" [label]="'Join reward'"
            [allowCoins]="false" [allowStamps]="!isPoints" [allowPoints]="isPoints">
          </app-reward-data-edit>
          }
          @if (isPunchCard) {
          <app-reward-data-edit fxFlex [hasToggle]="true" [formControl]="grp['controls'].firstConsRewardReceiver"
            [advertiser]="advertiser" [rewardProductsOptions]="rewardProducts" [label]="'First consumption reward'"
            [allowCoins]="false" [allowStamps]="!isPoints" [allowPoints]="isPoints">
          </app-reward-data-edit>
          }
          @if (!punchCardCampaignService.allowFlow) {
          @if (isPunchCard) {
          <app-reward-data-edit (onDataEndabledChanged)="onCompleteRewardToggleChange($event,i)" [hasToggle]="true"
            fxFlex [formControl]="grp['controls'].completeRewardReceiver" [advertiser]="advertiser"
            [rewardProductsOptions]="rewardProducts" [label]="'Complete reward'" [allowCoins]="false"
            [allowStamps]="!isPoints" [allowPoints]="isPoints">
          </app-reward-data-edit>
          }
          }
        </div>
        @if (punchCardCampaignService.allowFlow) {
        <mat-slide-toggle color="primary" class="reward-toggle" [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="dataValidations[i].isEnabledCompleteReward">
          <label class="form-label"
            [class.invalid]="!dataValidations[i]?.isEnabledCompleteReward && punchCardCampaignService.strategyType=='Stamps'">Complete
            reward</label>
        </mat-slide-toggle>
        @if (dataValidations[i]?.isEnabledCompleteReward) {
        <mat-accordion id="schemeList">
          @for (item of dataValidations[i]?.steps; track item; let idx = $index) {
          <mat-expansion-panel [class.invalid]="dataValidations[i]?.stepValidations[idx] == false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{item.title}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-campaign-flow-item (onProductRewardSelected)="onProductStepRewardSelected($event, idx)" [group]="i"
              [readonly]="true" [flow]="item" [allowCoins]="false" [allowStamps]="!isPoints"
              [allowPoints]="isPoints"></app-campaign-flow-item>
          </mat-expansion-panel>
          }
        </mat-accordion>
        }
        }
      </div>
    </div>
    }

  </div>


  <!-- <div><pre>{{ form.value | json }}</pre></div> -->

</form>

<lib-loading-overlay [isLoading]="isLoading" [message]="'loading...'" />